export default "__VITE_ASSET__B0z43hKh__"